"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.functions = exports.AccountRequestAccessRequestStatues = exports.AccountInitReponseStatuses = exports.AccountRequestActions = void 0;
const functions_1 = require("firebase/functions");
exports.AccountRequestActions = [
    "init",
    "verify",
    "artist",
    "password",
    "add-user",
    "request-access",
    "send-access-email",
    "approval",
];
exports.AccountInitReponseStatuses = [
    "error",
    "require-resume",
    "require-login",
    "ok",
];
exports.AccountRequestAccessRequestStatues = [
    "approve",
    "reject",
];
function account(req, app) {
    return (0, functions_1.httpsCallable)((0, functions_1.getFunctions)(app, "us-west2"), "signup-account")(req);
}
const spotify = async (app, options) => (0, functions_1.httpsCallable)((0, functions_1.getFunctions)(app, "us-central1"), "signup-spotify", options)();
exports.functions = {
    account,
    spotify,
};
//# sourceMappingURL=functions.js.map